import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Caution } from "@air/next-icons";
import { AlertBanner } from "@air/primitive-alert-banner";
import { detect } from "detect-browser";
import { memo, useState } from "react";
import { useMount } from "__barrel_optimize__?names=useMount!=!react-use";
const supportedBrowsers = {
    chrome: {
        type: "chrome",
        minVersion: 95,
        updateLink: "https://www.google.com/chrome/"
    },
    firefox: {
        type: "firefox",
        minVersion: 90,
        updateLink: "https://www.mozilla.org/firefox/new/"
    },
    safari: {
        type: "safari",
        minVersion: 15,
        updateLink: "https://support.apple.com/HT204416"
    },
    opera: {
        type: "opera",
        minVersion: 78,
        updateLink: "https://www.opera.com/download"
    },
    edge: {
        type: "edge",
        minVersion: 92,
        updateLink: "https://www.microsoft.com/en-us/edge"
    }
};
const getOutdatedBrowser = (browser)=>{
    if (!browser || !browser.version) {
        return null;
    }
    try {
        const majorVersion = parseInt(browser.version.split(".")[0], 10);
        switch(browser.name){
            case "edge":
            case "chrome":
            case "firefox":
            case "safari":
            case "opera":
                if (supportedBrowsers[browser.name].minVersion >= majorVersion) {
                    return supportedBrowsers[browser.name];
                }
                break;
        }
    } catch (_error) {
    // no need to do anything
    }
    return null;
};
export const OutdatedBrowserBanner = /*#__PURE__*/ memo(()=>{
    const [outdatedBrowser, setOutdatedBrowser] = useState(null);
    useMount(()=>{
        const browser = detect();
        setOutdatedBrowser(getOutdatedBrowser(browser));
    });
    if (!outdatedBrowser) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(AlertBanner, {
        color: "red",
        className: "sticky top-0 z-[10000]",
        prefix: /*#__PURE__*/ _jsx(Caution, {
            className: "size-4"
        }),
        children: [
            "Your browser is out of date. Please update your browser to the latest version by Mar 10, 2023 to receive the newest features and security fixes on Air”.\xa0",
            /*#__PURE__*/ _jsx("button", {
                className: "font-semibold",
                onClick: ()=>window.open(outdatedBrowser === null || outdatedBrowser === void 0 ? void 0 : outdatedBrowser.updateLink, "_blank"),
                children: "Learn more"
            })
        ]
    });
});
OutdatedBrowserBanner.displayName = "OutdatedBrowserBanner";
